const LOCAL_STORAGE_KEY = 'KDS'
const AUTO_BUMP_MINUTES = 15;

export default {
  defaultAppState() {
    return {
      pushNotificationList: [],
      autoBumpMinutes: AUTO_BUMP_MINUTES,
      kdsDetailView: true
    }
  },

  saveStateCookie(data) {
    var d = new Date();
    d.setTime(d.getTime() + (100 * 24 * 60 * 60 * 1000));
    var expires = 'expires='+d.toUTCString();
    document.cookie = LOCAL_STORAGE_KEY + '=' + JSON.stringify(data) + ';' + expires + ';path=/';
  },

  getStateCookie() {
    var result = document.cookie.match(new RegExp(LOCAL_STORAGE_KEY + '=([^;]+)'));
    result && (result = JSON.parse(result[1]));
    return result;
  },

  deleteStateCookie() {
    document.cookie = [LOCAL_STORAGE_KEY, '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/; domain=.', window.location.host.toString()].join('');
  }, 

  setLocalStorage(data) {
    console.log('set local storage: ' + LOCAL_STORAGE_KEY);
    // check for timeout before saving
    if (typeof(Storage) !== "undefined") {
      try {
        var strData = JSON.stringify(data);
        window.localStorage.setItem(LOCAL_STORAGE_KEY, strData);
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  },

  getLocalStorage() {
    console.log('get local storage');
    if (typeof(Storage) !== "undefined") {
      try {
        var strData = window.localStorage.getItem(LOCAL_STORAGE_KEY);
        var data = JSON.parse(strData)
        return data;
      } catch (e) {
        return null
      }
    } else {
      return null;
    }
  },

  clearLocalStorage() {
    if (typeof(Storage) !== "undefined") {
      console.log('clear local storage: ' + LOCAL_STORAGE_KEY);
      window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
  }

}


// WEBPACK FOOTER //
// ./src/appState/index.js